import { default as QueryWrapper } from './QueryWrapper';

export default QueryWrapper;
